import type { TranslationsBase } from './ko';

const ja: TranslationsBase = {
  lang: 'ja',
  langName: '日本語',
  flag: '🇯🇵',

  siteTitle: 'TOEFL 練習問題 無料 — 模試・AI分析 | Power TOEFL 2026',
  siteDescription: '2026年最新TOEFL iBTの練習問題3,500問以上と模試を無料で。AI弱点分析・エビングハウス復習。過去問ではありません。',
  ogTitle: 'TOEFL 練習問題 無料 — 模試・AI分析 | Power TOEFL 2026',

  navGrammar: '文法',
  navPractice: 'パート別練習',
  navScoreChart: 'スコア換算表',
  navVocabulary: '単語帳',
  navTips: 'ヒント/戦略',
  navFAQ: 'FAQ',
  navReading: 'Reading',
  navListening: 'Listening',
  navSpeaking: 'スピーキング',
  navWriting: 'ライティング',
  navQuestionPool: '問題バンク',
  navResources: '学習資料',

  loginButton: 'ログイン',
  wrongAnswers: '誤答ノート',
  logout: 'ログアウト',
  loginRequired: '誤答ノート＆続きから機能にはログインが必要です。',
  googleLogin: 'Googleで始めてプレミアム機能を有効化',

  heroBadge: 'プレミアム TOEFL 学習システム',
  heroTitle1: 'TOEFL高得点を目指す',
  heroTitle2: '唯一の学習サイト',
  heroDesc1: '2026年形式のReading・Listening・Speaking・Writing模試から誤答ノートまで、',
  heroDesc2: '目標スコア達成を完全にサポートします。',

  lcTitle: 'Listening',
  lcSubtitle: 'Listening — 47問',
  lcTime: '29分',
  rcTitle: 'Reading',
  rcSubtitle: 'Reading — 50問',
  rcTime: '30分',
  startTest: '試験開始',
  fullTestStart: '全模擬試験開始（Reading → Listening）',
  fullTestDesc: '2セクションを順番に解いてみましょう',

  part1: 'Academic Reading (20)',
  part2: 'Conversations (10)',
  part3: 'Lectures (18)',

  moreTools: 'その他の学習ツール',
  practiceLabel: 'パート別練習',
  practiceDesc: 'Reading·Listening 個別学習',
  scoreChartLabel: 'スコア換算表',
  scoreChartDesc: '正答数 → 換算スコア',
  vocabLabel: '単語帳',
  vocabDesc: 'TOEFL必須語彙',
  tipsLabel: 'ヒント/戦略',
  tipsDesc: 'Listening·Reading攻略法',
  catLabel: 'CATテスト',
  catDesc: '実力に合わせて難易度自動調整',
  fullTestCardLabel: 'Full Test模擬試験',
  fullTestCardDesc: 'Reading + Listening 2026年形式模試',

  statQuestions: '問',
  statParts: 'パート',
  statMinutes: '分',

  footerMockTest: '練習',
  footerQuestionPool: '問題バンク',
  footerPractice: 'セクション別練習',
  footerStudy: '学習',
  footerBooks: 'おすすめ教材',
  footerEtc: 'その他',
  footerLC: 'Listening練習',
  footerRC: 'Reading練習',
  footerSpeaking: 'Speaking練習',
  footerWriting: 'Writing練習',
  footerLCStrategy: 'Listening戦略',
  footerRCStrategy: 'RC 戦略',
  footerCopyright: '© 2026 Power TOEFL. All rights reserved.',
  footerDisclaimer: 'TOEFL®はETSの登録商標です。Power TOEFLはETSと提携・公認されたサイトではなく、独自に運営されるTOEFL学習プラットフォームです。',

  faqTitle: '❓ よくある質問（FAQ）',
  faqDesc: 'TOEFL試験とPower TOEFLについてのよくある質問をご確認ください。',
  faqPageTitle: 'TOEFLスコア計算・申込方法・有効期限 — 2026年FAQ完全ガイド | Power TOEFL',
  faqPageDesc: 'TOEFLの申込方法、スコア換算、有効期限、パート別攻略法まで — 受験者が最もよく聞く質問30個を一ページで確認。',
  faqMore: 'もっと知りたいことがありますか？FAQを随時更新しています。',

  scoreChartPageTitle: 'TOEFLスコア換算表 2026 — 正答数で何点？今すぐ確認 | Power TOEFL',
  scoreChartPageDesc: 'TOEFL正答数から予想スコアを即確認。LC・RC別換算表＋目標スコア別学習ガイドまで無料で提供。あなたの正答数を入力するだけ。',
  scoreChartHeading: '📊 TOEFLスコア換算表',
  scoreChartIntro: '0～30のセクション表と0～120の総合表は、従来の比較用尺度によるPower TOEFLの学習用推定値です。2026年の公式レポートは各セクションと総合を1～6（0.5刻み）で表示します。',
  scoreChartLC: 'LC (Listening) 換算表',
  scoreChartRC: 'RC (Reading) 換算表',
  scoreChartCorrect: '正答数',
  scoreChartConverted: '換算スコア',
  scoreChartUnit: '問',
  scoreChartPointUnit: '点',
  scoreGuideTitle: '🎯 目標スコア別ガイド',
  scoreGuide900: '最上位',
  scoreGuide900Desc: 'LC 90+ / RC 90+ 正答必要。ほぼ満点レベル。',
  scoreGuide800: '上位',
  scoreGuide800Desc: 'LC 80+ / RC 80+ 正答目標。上級ビジネス英語。',
  scoreGuide700: '中上位',
  scoreGuide700Desc: 'ほとんどの就職条件を満たす。継続学習が必要。',
  scoreGuide600: '中級',
  scoreGuide600Desc: '基礎力あり。Reading と Listening の集中学習推奨。',
  scoreChartFaqTitle: '❓ TOEFLスコアに関するよくある質問',
  scoreChartCtaTitle: '今すぐ実力を確認しましょう',
  scoreChartCtaDesc: '無料模試で予想スコアを確認しましょう。',

  vocabPageTitle: 'TOEFL頻出単語600語 — カテゴリ別に意味・例文を即暗記 | Power TOEFL',
  vocabPageDesc: 'ビジネス・人事・マーケティング・金融・製造・日常の6カテゴリ600語。クリックで意味と例文が表示される単語帳で効率的に暗記。',
  vocabHeading: '📚 TOEFL必須単語帳',
  vocabIntro: 'カテゴリ別の必須単語を学習してください。クリックで意味が表示されます。',
  vocabShowAll: 'すべて表示',
  vocabHideAll: 'すべて隠す',
  vocabReset: 'リセット',
  vocabClickToReveal: 'クリックで意味を表示',
  vocabMotivation: '繰り返し学習すればTOEFLスコアが上がります！🚀',
  vocabCatNaturalScience: '自然科学',
  vocabCatSocialScience: '社会科学',
  vocabCatHumanities: '人文学',
  vocabCatLifeScience: '生命科学',
  vocabCatTechnology: '技術/工学',
  vocabCatAcademicGeneral: '学術一般',
  vocabSynonyms: '同義語',
  vocabAntonyms: '反義語',
  vocabMyWords: 'マイ単語帳',
  vocabAddWord: '単語追加',
  vocabAddWordPlaceholder: '英単語を入力',
  vocabMyWordsEmpty: 'まだ単語がありません。上から追加してみましょう！',
  vocabDeleteWord: '削除',
  vocabLookingUp: '検索中...',
  vocabQuizTitle: '単語クイズ',
  vocabQuizDesc: '学習した単語の同義語・反義語を当ててみましょう！',
  vocabQuizMode_synonym: '同義語クイズ',
  vocabQuizMode_antonym: '反義語クイズ',
  vocabQuizMode_mixed: 'ミックスクイズ',
  vocabQuizClose: '閉じる',
  vocabQuizNoQuestions: 'このカテゴリにはクイズ問題が不足しています。',
  vocabQuizBack: '戻る',
  vocabQuizResult: 'クイズ結果',
  vocabQuizExcellent: '素晴らしい！🎉',
  vocabQuizGood: 'よくできました！もう少し練習すれば完璧！',
  vocabQuizKeepGoing: '引き続き頑張りましょう！💪',
  vocabQuizRetry: 'もう一度',
  vocabQuizFindSynonym: '次の単語の同義語を選んでください',
  vocabQuizFindAntonym: '次の単語の反義語を選んでください',
  vocabQuizNext: '次へ',
  vocabQuizFinish: '結果を見る',
  vocabQuizStart: 'クイズ開始',

  tipsLCPageTitle: 'TOEFLリスニング スコアを上げる方法 | LC実戦トレーニング — Power TOEFL',
  tipsLCPageDesc: 'TOEFLリスニングスコアを上げる実戦トレーニング法。Conversations・Lectures ノートテイキング、推論、態度把握問題まで完全対策。',
  tipsLCHeading: '🎧 TOEFLリスニング スコアを上げる方法',
  tipsLCIntro: 'TOEFL LCパート別核心攻略法と実戦トレーニングルーティンをまとめました。',
  tipsLCButton: 'LC 戦略',
  tipsRCButton: 'RC 戦略',
  tipsLCPractice: 'LC 実践練習',
  tipsLCPracticeDesc: '戦略を覚えたら模擬試験で練習しましょう。',
  tipsLCStartTest: 'LC 模擬試験開始',
  tipsRCPageTitle: 'TOEFLリーディング 時間不足の解決法 | RC時間配分戦略 — Power TOEFL',
  tipsRCPageDesc: 'TOEFLリーディング時間不足の解決法。TOEFL Reading の学術文章攻略法。キーワードスキャン、推論、要約問題の戦略で読解スコアアップ。',
  tipsRCHeading: '📖 TOEFLリーディング 時間不足の解決法',
  tipsRCIntro: 'TOEFL RC時間配分戦略とパート別攻略法をまとめました。',
  tipsRCPractice: 'RC 実践練習',
  tipsRCPracticeDesc: '戦略を覚えたら模擬試験で練習しましょう。',
  tipsRCStartTest: 'RC 模擬試験開始',

  practicePartMeta: {
    '1': { title: 'TOEFL Reading 学術文章攻略 — 20問完全戦略 | Power TOEFL', desc: 'TOEFL Reading 学術文章を効果的に読む方法。キーワードスキャン、推論問題、要約問題の攻略を一気にまとめます。' },
    '2': { title: 'TOEFL Listening 会話攻略 — ノートテイキング戦略 | Power TOEFL', desc: 'TOEFL Listening Conversations の核心戦略。教授と学生の会話の目的把握、態度推論、ノートテイキング技法を解説。' },
    '3': { title: 'TOEFL Listening 講義攻略 — 18問核心戦略 | Power TOEFL', desc: 'TOEFL Listening Lectures の攻略法。講義のテーマ把握、教授の意図推論、例示分析で高得点を達成。' },
  } as Record<string, { title: string; desc: string }>,

  practicePartContent: {
    '1': {
      intro: 'TOEFL Reading セクションは学術文章（約700語）を読み、テーマ、詳細情報、推論、語彙、要約問題に答える形式です。35分で2つの文章、計20問を解きます。各段落のトピック文把握とキーワードスキャンが時間管理の鍵です。',
      commonTypes: ['テーマ・目的把握 (What is the passage mainly about?)', '詳細情報 (According to the passage...)', '語彙問題 (The word X is closest in meaning to...)', '推論問題 (What can be inferred?)', '文挿入 (Insert text)', '要約問題 (Prose Summary — 核心3つを選択)'],
      strategy: ['質問を先に読みキーワード2~3個を覚えてから文章をスキャン', '各段落の最初の文（トピック文）に集中 — TOEFL学術文章はほとんど頭括型', '語彙問題は辞書的意味ではなく文脈の中の意味で判断', '要約問題は細部ではなく核心アイデア3つだけを選択'],
      recommendedFor: ['TOEFL入門者 — 学術文章の読解感覚をつかむ', 'Reading 20点以上目標 — 時間配分戦略が必須', '推論・要約問題が弱い学習者 — タイプ別集中訓練'],
      faq: [
        { q: 'TOEFL Readingで時間が足りない時は？', a: '1文章あたり17~18分を配分し、難しい問題はマークして飛ばしましょう。要約問題に最低3分残すことが鍵です。' },
        { q: '語彙問題で知らない単語が出たら？', a: '文脈から意味を推論しましょう。空所前後の文がヒントです。辞書的意味と異なることがあります。' },
        { q: '要約問題(Prose Summary)はどう解く？', a: '細部ではなく各段落の核心アイデアを代表する3つの選択肢を選びます。1つの段落だけに該当する細部は不正解です。' },
      ],
    },
    '2': {
      intro: 'TOEFL Listening Conversationsはキャンパス内の会話（教授と学生、職員と学生）を聞いて質問に答える形式です。約3~5分の会話を聞き5問を解き、会話の目的、詳細情報、話者の態度を把握することが鍵です。',
      commonTypes: ['会話の目的 (Why does the student visit the professor?)', '詳細情報 (What does the professor say about...?)', '話者の態度・意図 (What is the student\'s attitude?)', '次の行動 (What will the student probably do next?)'],
      strategy: ['会話冒頭で訪問目的を即座に把握', 'ノートテイキングで核心情報（名前、日付、条件）を記録', '話者の口調と感情表現に注意 — 態度問題の核心ヒント', '会話最後の結論や次の行動に集中'],
      recommendedFor: ['TOEFL Listening 15点以下 — 短い会話から感覚をつかむ', 'Lecturesより簡単なタイプから始めたい学習者', 'ノートテイキング練習が必要な学習者'],
      faq: [
        { q: 'Conversationsでノートテイキングは必須？', a: 'はい。TOEFLは会話後に問題が表示されるため、記憶だけでは細部を見逃します。略語と記号を活用した素早いメモが鍵です。' },
        { q: '話者の態度をどう把握する？', a: '口調（確信/不確実）、感情表現("I\'m not sure about that", "That sounds great")、繰り返しの強調が態度問題の核心ヒントです。' },
      ],
    },
    '3': {
      intro: 'TOEFL Listening Lecturesは大学講義（約5~7分）を聞いて6問に答える形式です。生物学、歴史、芸術、地質学など様々な学術テーマが出題され、講義テーマの把握、教授の意図推論、例示の目的分析が鍵です。',
      commonTypes: ['講義テーマ (What is the lecture mainly about?)', '教授の意図 (Why does the professor mention X?)', '詳細情報 (According to the professor...)', '推論 (What does the professor imply?)', '講義構造 (How does the professor organize the lecture?)'],
      strategy: ['講義の最初1~2分でテーマと目的を把握 — 最も基本的な問題タイプ', '教授が例を挙げる理由を常に考える — "Why does the professor mention X?"の核心', '転換表現(Now, let\'s move on to...)で新しいサブトピック開始', '教授の反語的表現、ユーモア、修辞疑問の意味を推論'],
      recommendedFor: ['TOEFL Listening 20点以上目標 — Lecturesがスコアの鍵', '学術講義の聴取が困難な学習者', 'ノートテイキング体系を整えたい学習者'],
      faq: [
        { q: '"Why does the professor mention X?"はどう解く？', a: '教授が例・比喩・実験を言及する理由は通常、前に説明した概念を補足または対比するためです。言及直前の文脈で目的を探しましょう。' },
        { q: 'Lecturesで背景知識がないと不利？', a: 'いいえ。TOEFLは講義内で必要な情報をすべて提供します。背景知識は助けになりますが、講義内容だけで全問題を解けるよう設計されています。' },
      ],
    },
  } as Record<string, { intro: string; commonTypes: string[]; strategy: string[]; recommendedFor: string[]; faq: { q: string; a: string }[] }>,

  practiceRelatedLinks: '📌 関連学習コンテンツ',
  practiceOtherParts: '他のパート攻略',
  practiceMockTestCTA: '模擬試験で実践練習',
  practiceTipsLink: 'パート別戦略を見る',
  practiceGrammarLink: '文法を学ぶ',

  practiceNotFound: 'パートが見つかりません。',
  practiceQuestionType: '問題タイプ',
  practiceTips: '💡 攻略ヒント',
  practiceExamples: '📝 例題',
  practiceIntro: '📋 パート紹介',
  practiceCommonTypes: '📊 よく出る類型',
  practiceStrategy: '🎯 攻略ポイント',
  practiceRecommendedFor: '👤 こんな学習者におすすめ',
  practiceFAQ: '❓ よくある質問',
  practiceCTA: '今すぐ練習しましょう',
  practiceCTADesc: '本番と同じ環境でPart {0}を解くことができます。',
  practiceStartTest: '{0} 模擬試験開始',
  practiceQuestions: '問',
  practicePartSelect: 'パート選択',

  roundsTitle: '模擬試験 回次',
  roundLabel: 'TOEFL模擬試験',
  roundUnit: '回',
  comingSoon: '準備中',
  testPrevious: '前へ',
  testNext: '次へ',
  testQuestion: '問題',
  testQuestionPrompt: '次の問題を見て正しい答えを選んでください。',
  testMarkAnswer: '正しい答えの番号をマークしてください。',
  testSelect: '選択',
  testShowAnswer: '正解と解説を見る',
  testCorrect: '正解です！',
  testIncorrect: '不正解です。',
  testLoginPrompt: '誤答ノート＆続きから機能にはログインが必要です。',
  testGoogleLogin: 'Googleで3秒ログイン',
  roundSelect: '他の回次を選択',
  testAnswered: '回答済み',
  testSubmit: '試験提出',
  testSubmitTitle: '{0}試験を提出しますか？',
  testSubmitDesc: '{0}問中{1}問に回答しました。',
  testUnanswered: '{0}問が未回答です。',
  testCannotUndo: 'この操作は取り消せません。',
  testContinue: '続ける',
  testSubmitBtn: '提出',

  resultsTitle: '{0} 試験結果',
  resultsTimeUsed: '所要時間：{0}分{1}秒',
  resultsEstimatedScore: '予想スコア（30点満点）',
  resultsCorrect: '正解',
  resultsIncorrect: '不正解',
  resultsAccuracy: '正答率',
  resultsReview: '回答確認',
  resultsYourAnswer: 'あなたの回答：{0}',
  resultsCorrectAnswer: '正解：{0}',
  resultsNoAnswer: '未回答',
  resultsHome: 'ホーム',
  resultsWrongNotes: '誤答ノート',
  resultsRetry: 'もう一度',
  resultsShare: '結果をシェア',
  resultsShareText: '私のTOEFL {0} 予想スコアは{1}点！({2}/{3}正解、正解率{4}%) Power TOEFLで無料でテスト！',
  resultsShareCopied: '結果がクリップボードにコピーされました！',
  resultsNoResults: '試験結果がありません。',
  resultsGoHome: 'ホームへ',
  resultsSaved: '誤答{0}問が誤答ノートに保存されました',

  wrongAnswersTitle: '誤答ノート',
  wrongAnswersSaved: '保存された問題',
  wrongAnswersHome: 'ホーム',
  wrongAnswersPracticeAll: '全て練習',
  wrongAnswersAll: '全て',
  wrongAnswersNoItems: 'まだ誤答がありません。まずテストを受けてください！',
  wrongAnswersYourAnswer: 'あなたの回答：{0}',
  wrongAnswersCorrectIs: '正解：{0}',
  wrongAnswersReviewed: '復習済み',
  wrongAnswersRemoved: '誤答ノートから削除しました',
  wrongAnswersPracticeMode: '練習モード',
  wrongAnswersCorrectMsg: '正解です！',
  wrongAnswersIncorrectMsg: '不正解。正解：{0}',
  wrongAnswersNextQuestion: '次の問題',
  wrongAnswersFinish: '練習終了',
  wrongAnswersExitPractice: '練習を終了',
  wrongAnswersPracticeComplete: '練習完了！',
  wrongAnswersNoPractice: '練習する誤答がありません',
  wrongAnswersLimitNotice: '最新500件の誤答のみ表示されます。',

  privacyPageTitle: 'プライバシーポリシー — Power TOEFL',
  privacyPageDesc: 'Power TOEFLのプライバシーポリシーです。',
  privacyHeading: 'プライバシーポリシー',
  privacyLastUpdated: '最終更新日：2026年3月29日',
  privacyS1Title: '1. 収集する個人情報',
  privacyS1Body: 'Power TOEFLは、サービス提供のためにGoogleログイン時にメールアドレス、名前、プロフィール写真を収集します。有料決済時は決済サービス（Dodo Payments/PayPal）を通じて決済情報が処理され、当社は決済カード情報を直接保存しません。',
  privacyS2Title: '2. 個人情報の利用目的',
  privacyS2Body: '収集した個人情報は誤答ノート保存、学習進捗管理、サブスクリプション管理、カスタマーサポート、サービス改善の目的でのみ使用されます。',
  privacyS3Title: '3. 個人情報の保管および破棄',
  privacyS3Body: '退会時に個人情報は直ちに破棄されます。ただし決済記録は関連税法に基づき最大5年間保管後に破棄します。',
  privacyS4Title: '4. 第三者への個人情報提供',
  privacyS4Body: '本サービスは決済処理のためにDodo Payments（Merchant of Record）またはPayPalに必要最小限の情報（メール）を提供します。その他、ユーザーの個人情報を第三者に提供することはありません。',
  privacyS5Title: '5. クッキーおよび広告',
  privacyS5Body: '本サイトはGoogle AdSenseを通じて広告を掲載しており、そのためにクッキーを使用します。クッキーはブラウザの設定で管理できます。',
  privacyS6Title: '6. 国際データ転送',
  privacyS6Body: '本サービスは海外サーバーを使用しており、決済処理のためにデータが国際的に転送される場合があります。適切なセキュリティ対策により個人情報を保護します。',
  privacyS7Title: '7. ユーザーの権利',
  privacyS7Body: 'ユーザーはいつでも自分の個人情報の閲覧、修正、削除を要求できます。EU/EEA居住者はGDPRに基づく追加の権利が保障されます。',
  privacyS8Title: '8. お問い合わせ',
  privacyS8Body: '個人情報に関するお問い合わせは、skdaks0731@gmail.comまでご連絡ください。',

  termsPageTitle: '利用規約 — Power TOEFL',
  termsPageDesc: 'Power TOEFLの利用規約です。',
  termsHeading: '利用規約',
  termsLastUpdated: '最終更新日：2026年3月29日',
  termsS1Title: '1. サービス概要',
  termsS1Body: 'Power TOEFLは、TOEFL試験対策のためのオンライン学習プラットフォームであり、登録された正式な事業者名 ddookddak が運営しています。無料機能と有料プレミアム（Pro/Lifetime）サブスクリプションを通じて模擬テスト、パート別練習、AI問題生成、誤答ノートなどの機能を提供します。',
  termsS2Title: '2. 利用条件',
  termsS2Body: '本サービスは14歳以上であればどなたでもご利用いただけます。一部の機能（誤答ノート、AI練習など）にはGoogleアカウントでのログインが必要であり、プレミアム機能には有料サブスクリプションが必要です。',
  termsS3Title: '3. 知的財産権',
  termsS3Body: '本サイトのコンテンツ（問題、デザイン、コードなど）はPower TOEFLに帰属します。TOEFLはETSの登録商標であり、本サイトはETSとは関係ありません。',
  termsS4Title: '4. 有料サービスおよび決済',
  termsS4Body: 'プレミアムサブスクリプションは第三者決済サービス（Dodo Payments/PayPal）を通じて処理されます。料金は選択したプラン（月額/年額/ライフタイム）に応じて自動または一回限りで請求されます。すべての価格にはVATが含まれる場合があります。返金ポリシーは別途ご確認ください。',
  termsS5Title: '5. 免責事項',
  termsS5Body: '本サービスで提供する模擬テストのスコアおよび学習資料は参考用であり、実際のTOEFL試験の結果を保証するものではありません。',
  termsS6Title: '6. 禁止事項',
  termsS6Body: 'サービスを利用して問題を無断で複製・配布する行為、システムに過度な負荷をかける行為、アカウントの共有、その他違法行為を禁止します。',
  termsS7Title: '7. サービスの変更・中断',
  termsS7Body: '運営者はサービスを事前通知なく変更または中断することがあり、これに対する補償は行いません。',
  termsS8Title: '8. サブスクリプション解約',
  termsS8Body: '有料サブスクリプションはいつでも解約できます。解約後も残りの決済期間まではプレミアム機能をご利用いただけます。',
  termsS9Title: '9. 規約の変更',
  termsS9Body: '本規約は必要に応じて変更されることがあり、変更時はサイトで告知します。変更後もサービスを利用した場合、変更後の規約に同意したものとみなします。',

  refundPageTitle: '返金ポリシー — Power TOEFL',
  refundPageDesc: 'Power TOEFLプレミアム購読の返金ポリシーです。',
  refundHeading: '返金ポリシー',
  refundLastUpdated: '最終更新日：2026年4月15日',
  refundS1Title: '1. 返金原則',
  refundS1Body: 'デジタル商品の特性上、原則として返金はできません。',
  refundS2Title: '2. 例外的な返金',
  refundS2Body: 'ただし、法令上の要請、重複決済、サービス未提供、重大な技術障害が確認された場合は、例外的に返金されることがあります。',
  refundS3Title: '3. 問い合わせ方法',
  refundS3Body: '返金に関するお問い合わせはサポート/ご意見窓口をご利用ください。連絡先: skdaks0731@gmail.com',
  refundS4Title: '4. サブスクリプション解約',
  refundS4Body: '有料サブスクリプションはいつでも解約できます。解約後も現在の請求期間が終了するまでは利用でき、以後の追加請求は発生しません。',
  refundS5Title: '',
  refundS5Body: '',
  refundS6Title: '',
  refundS6Body: '',

  footerPrivacy: 'プライバシーポリシー',
  footerTerms: '利用規約',
  footerRefund: '返金ポリシー',
  footerAbout: 'サイト紹介',
  footerGuide: '学習ガイド',
  guideLabel: '学習ガイド',
  guideDesc: 'スキル別攻略・スコア別戦略・試験比較情報',

  aboutPageTitle: '無料TOEFL模試 + AI弱点分析 — Power TOEFLとは | 2026',
  aboutPageDesc: '2026年TOEFL iBT形式の練習、AI弱点分析、誤答自動復習。Power TOEFLの機能を紹介します。',
  aboutHeading: 'Power TOEFL — TOEFL実戦模擬テスト学習プラットフォーム',
  aboutS1Title: 'Power TOEFLとは？',
  aboutS1Body: 'Power TOEFLはTOEFL iBT学習者向けのオンライン練習プラットフォームです。2026年改訂形式のセクション別練習、AIフィードバック、誤答ノートを提供します。ETS公式問題ではなく、独自制作の学習コンテンツです。',
  aboutS2Title: 'どんな方におすすめ？',
  aboutS2Body: 'TOEFL初心者の大学生、目標スコアが必要な社会人、海外就職を目指す方、独学でTOEFLを勉強するすべての方におすすめです。',
  aboutS3Title: '主な機能',
  aboutFeature1: '2026年形式 Reading・Listening・Speaking・Writing模試',
  aboutFeature2: 'Reading·Listening セクション別集中練習',
  aboutFeature3: 'AI による難易度別カスタム問題生成＆弱点分析',
  aboutFeature4: '間違えた問題を自動保存する誤答ノート＋エビングハウス復習',
  aboutFeature5: 'スコア換算表とTOEFL必須単語帳',
  aboutS4Title: '無料とプレミアムの違い',
  aboutS4Body: '無料で模擬テスト、パート別練習、スコア換算表が利用できます。プレミアム（Pro）ではAI無制限問題生成、広告除去、全回の模擬テストが利用可能です。',
  aboutS5Title: 'なぜ実力が上がるのか？',
  aboutS5Body: 'エビングハウス忘却曲線に基づく復習とセクション別弱点分析で反復学習を助けます。スコア上昇幅は開始レベル・学習量・当日のコンディションにより異なり、特定の上昇を保証しません。',
  aboutS6Title: 'ETSとの関係',
  aboutS6Body: 'Power TOEFLはETSと提携または公認されたサイトではありません。TOEFL®はETSの登録商標であり、本サイトは独自に運営される学習プラットフォームです。',
  aboutS7Title: 'お問い合わせ',
  aboutS7Body: 'サービスに関するお問い合わせは skdaks0731@gmail.com までご連絡ください。',
  aboutCtaHeading: '今すぐ始めましょう',
  aboutCtaDesc: '無料で実戦模擬試験に挑戦してみましょう。',
  aboutCtaStart: '模試を始める',
  aboutCtaPricing: 'プレミアムプランを見る',

  resumeTest: '続きから',
  resumeDesc: '{0} {1}回 — {2}/{3}問',
  progressLabel: '進捗',
  timerLabel: '残り時間',
  timeUp: '時間切れです！',
  navHome: 'ホーム',
  navSettings: 'ヒント/戦略',

  grammarSectionTitle: '英文法 Book',
  grammarSectionDesc: 'TOEFL必須文法を体系的に学習しましょう',
  grammarViewAll: 'すべて見る',
  grammarChapter: 'チャプター',

  aiPracticeTitle: 'AI TOEFL問題を無限生成 — パート・難易度を選ぶと即出題 | Power TOEFL',
  aiPracticeDesc: 'パートと難易度を選ぶだけでAIがTOEFL問題を即時生成。解説付き無料練習問題で毎日新しい問題に挑戦。',
  aiPracticeH1: '✨ AI TOEFL問題生成',
  aiPracticeSub: 'AIが難易度に合わせたTOEFL問題をリアルタイムで生成します。',
  aiPartLabel: 'パート',
  aiDiffLabel: '難易度',
  aiBeginner: '初級（1.0–2.5）',
  aiIntermediate: '中級（3.0–4.5）',
  aiAdvanced: '上級（5.0–6.0）',
  aiGenerate: '問題生成',
  aiGenerating: '生成中...',
  aiRemainingToday: '今月あと{0}回',
  aiLimitReached: '今月のAIクレジットを使い切りました',
  aiLimitUpgrade: 'クレジットを追加購入またはアップグレード！',
  aiUpgrade: 'アップグレード',
  aiListenPrompt: '🔊 LC問題は音声を聞きながら解きましょう',
  aiPlayAudio: '音声再生',
  aiStopAudio: '停止',
  aiCorrect: '✅ 正解です！',
  aiWrong: '❌ 不正解です。',
  aiCorrectAnswer: '正解: {0}',
  aiPrev: '前へ',
  aiNext: '次へ',
  aiNewQuestions: '新しい問題',
  aiEmptyTitle: 'AIで問題を生成しましょう',
  aiEmptyDesc: 'パートと難易度を選んで「問題生成」ボタンを押してください。',
  aiLoadingMain: 'AIが問題を生成・検証しています...',
  aiLoadingSub: '約10~20秒かかります',

  statsTitle: 'TOEFL学習統計 — Power TOEFL',
  statsDesc: 'TOEFL文法クイズ正答率、誤答ノート復習状況など学習統計を一目で。',
  statsH1: '📊 学習統計',
  statsLoginPrompt: 'ログインすると学習統計を確認できます。',
  statsTotalQuizzes: '総クイズ数',
  statsTotalQuestions: '総問題数',
  statsAccuracy: '正答率',
  statsLast7Days: '直近7日間',
  statsWrongSummary: '誤答ノート状況',
  statsViewAll: '誤答ノートを見る',
  statsTotalWrong: '総誤答',
  statsReviewed: '復習済み',
  statsPending: '未復習',
  statsTopicAccuracy: '文法トピック別正答率',
  statsAttempts: '{0}回解答',
  statsEmpty: 'まだ学習記録がありません。文法クイズに挑戦しましょう！',
  statsStartGrammar: '文法学習を始める',

  pricingTitle: '無料で足りない時 — Power TOEFL Pro料金比較（月¥2,480）| 2026',
  pricingDesc: '無料は1日10問（未ログイン3問）と月1回フル模試。Proは無制限演習・解説・AIフィードバック・広告なし。月額2,480円。',

  testLCTitle: 'TOEFL Reading模試 無料 — 学術パッセージ読解 | 2026',
  testLCDesc: '2026年TOEFL Reading模試を無料で。学術パッセージ中心、誤答ノート自動保存。',
  testRCTitle: 'TOEFL Listening模試 無料 — 会話・講義リスニング | 2026',
  testRCDesc: '2026年TOEFL Listening模試を無料で。会話と講義、AI解説・誤答ノート付き。',

  reviewTitle: '今日の復習',
  reviewDesc: 'エビングハウス忘却曲線に基づくスマート復習',
  reviewSubtitle: '忘却曲線に沿って最適なタイミングで復習しましょう',
  reviewRemaining: '残りの復習',
  reviewProgress: '復習の進捗',
  reviewCompleted: '🎉 今日の復習完了！',
  reviewCompletedDesc: '{0}問を復習しました',
  reviewEmpty: '今日復習する問題はありません',
  reviewEmptyDesc: 'すべて復習済みか、まだ誤答がありません。',
  reviewStage: 'ステージ{0}',
  reviewNextInterval: '{0}日間隔',
  reviewCorrect: '正解！次のステージへ進みます。',
  reviewWrong: '不正解。ステージ1からやり直します。',
  reviewNextReview: '次の復習: {0}日後',
  reviewResetMsg: '間違えたため、1日後に再復習します。',
  reviewNext: '次の問題',
  reviewFinish: '完了',
  reviewHowItWorks: 'エビングハウス復習の仕組み',
  reviewDaysLater: '{0}日後',
  reviewExplanation: '誤答は1日→3日→7日→14日→30日→60日の間隔で復習。正解で次のステージへ、不正解でステージ1に戻ります。',
  notifTitle: '通知',
  notifEmpty: '新しい通知はありません',
  notifMarkAllRead: 'すべて既読',
  timeJustNow: 'たった今',
  timeMinutes: '{0}分前',
  timeHours: '{0}時間前',
  timeDays: '{0}日前',
  scoreCardEstimated: '推定スコア',
  scoreCardCorrect: '正解',
  scoreCardIncorrect: '不正解',
  scoreCardAccuracy: '正答率',
  pushTitle: '学習通知を受け取る',
  pushDesc: '復習のタイミングや連続学習記録をお知らせします。',
  pushEnable: '通知をオンにする',
  navReview: '復習',
  navStats: '統計',
  navPremium: 'プレミアム',
  navSubscription: 'サブスク管理',
  roundDetailHeading: 'TOEFL模擬試験',
  roundDetailOtherRounds: '他の回を見る',
  roundSuffix: '回',
  footer7DayPlan: '7日間勉強法',
  footerTrapPatterns: 'ひっかけパターン',
  pwaAddToHome: '📱 ホーム画面に追加',
  pwaAddToHomeDesc: 'アプリのようにすぐ起動！オフラインでも学習可能',
  pwaInstall: 'インストール',
  pwaIOSGuide: '共有 → ホーム画面に追加',
  aiQuizTitle: '🤖 AIカスタム練習問題',
  aiQuizDesc: 'AI生成TOEFL文法問題',
  aiQuizGenerateDesc: '文法に合わせたTOEFL文法形式の問題5問をAIがリアルタイムで生成します。',
  aiQuizGenerate: 'AI問題を生成',
  aiQuizGenerating: '🤖 AIが問題を生成中...',
  aiQuizGeneratingTime: '約5~10秒かかります',
  aiQuizNew: '新しい問題',
  aiQuizStats: '累計統計:',
  aiQuizTimes: '回',
  aiQuizCheckAnswers: '答え合わせ',
  aiQuizPerfect: '🎉 全問正解！',
  aiQuizCorrectCount: '正解',
  aiQuizSaving: '結果保存中...',
  aiQuizTryNew: '新しい問題に挑戦',
  aiQuizError: 'AI問題生成に失敗しました。もう一度お試しください。',
  tipsDetailStrategy: '詳細戦略',
  tips7DayTitle: '🗓️ 試験直前7日間の勉強法',
  tips7DayDesc: '直前ルーティンでスコアを最大化',
  tipsTrapTitle: '⚠️ ひっかけパターン総まとめ',
  tipsTrapDesc: 'よく引っかかる5大パターンを事前に把握',
  pricingSaveBadge: '30%割引',
  pricingPerMonth: '月',
  pricingSSL: 'セキュア決済',
  pricingCurrentPlan: '現在のプラン',
  pricingFaqQ1: '無料とProの違いは？',
  pricingFaqA1: '無料プランはReading·Listeningの基本問題と1日1回のAI練習が含まれます。Proは無制限AI模試、Speaking·WritingのAIフィードバック、4セクション弱点分析、広告除去などが含まれます。',
  pricingFaqQ2: '返金はできますか？',
  pricingFaqA2: 'デジタル商品の性質上、原則として返金はできません。ただし、法令上の要請、重複決済、サービス未提供、重大な技術障害が確認された場合は例外的に返金されることがあります。',
  pricingFaqQ3: 'サブスクリプションの解約方法は？',
  pricingFaqA3: 'マイサブスクリプションページからいつでも解約できます。解約後も残りの期間まで利用可能です。',
  pricingFaqQ4: 'LifetimeとPro年間プランの違いは？',
  pricingFaqA4: 'Lifetimeは一回の支払いで永久に全機能を利用できます。Pro年間は毎年更新が必要です。',
  proBadgeLabel: 'Pro',
  pricingCard: 'カード決済',
  pricingPaymentSuccess: 'プレミアム登録完了！',
  pricingPaymentCancelled: '決済がキャンセルされました',
  pricingLoginRequired: 'ログインが必要です',
  pricingPaymentError: '決済の作成に失敗しました。',
  subLoginRequired: 'ログインが必要です。',
  grammarSystematic: '体系的な文法学習',
  grammarBookTitle: 'TOEFL文法ガイド',
  grammarBookDesc: 'TOEFL必須文法20項目を体系的に学習。各章に実践例文と練習問題付き。',
  grammarTestAfter: '文法学習後すぐに実力テスト！',
  grammarTestAfterDesc: '学んだ文法が実際のTOEFLでどう出題されるか確認',
  grammarMockTest: 'Mock Test',
  grammarDoneTitle: '文法学習を終えましたか？',
  grammarDoneDesc: '模擬試験で学んだ内容をすぐに適用しましょう。間違えた問題は誤答ノートに自動保存！',
  grammarStartRC: 'RC模擬試験開始',
  grammarPracticePart5: 'Reading 文法練習',
  grammarCourseName: 'TOEFL文法完全ガイド',
  grammarBreadcrumb: '文法ガイド',
  grammarHome: 'ホーム',
  grammarExamples: '実践例文',
  grammarTestKnowledge: '📝 実力テスト',
  grammarTestKnowledgeDesc: '学んだ文法の実戦問題に挑戦！',
  grammarCheckAnswers: '答え合わせ',
  grammarPerfect: '🎉 全問正解！',
  grammarCorrectCount: '正解',
  grammarMockCTA: '🔥 模擬試験で実力を検証！',
  grammarMockCTADesc: 'RC 100問模擬試験 + 誤答ノート自動生成',
  grammarStartRCMock: 'RC模擬試験開始',
  grammarPractice5: 'Reading 練習',
  grammarTestInPractice: '実戦で確認！',
  grammarTestInPracticeDesc: '文法ポイントが実際のTOEFLでどう出題されるか確認しましょう。',
  grammarRelated: '📚 関連文法',
  wrongAnswersGrammarAI: 'Grammar AI',
  streakDays: '日',
  streakLabel: '連続学習',
  leaderboardTitle: '学習ランキング',
  leaderboardWeekly: '週間',
  leaderboardMonthly: '月間',
  leaderboardLoading: '読み込み中...',
  loadingQuestions: '問題を読み込んでいます...',
  leaderboardEmpty: 'まだ今{period}のデータがありません',
  leaderboardEmptyWeek: '週',
  leaderboardEmptyMonth: '月',
  leaderboardHint: '試験を解くと自動的にランキングに登録されます！',
  leaderboardRank: '順位',
  leaderboardNickname: 'ニックネーム',
  leaderboardSolved: '問題数',
  leaderboardAccuracy: '正答率',
  leaderboardMe: '自分',
  leaderboardMyRank: '🏅 自分の順位: {rank}位',
  tipsCoreTips: '核心攻略ヒント',
  tipsStrategy: '実戦戦略',
  tipsCTA: '戦略を学んだら実戦へ！',
  testScrollHint: 'スクロールすると問題と選択肢が表示されます',
  testPart1Label: 'Academic Reading',
  testPart2Title: 'Conversations',
  testPart2Desc: '音声を聞いて正解を選んでください',
  testPart3Label: 'Lectures',
  streak7: '1週間連続学習中！',
  streak14: '2週間連続達成！',
  streak30: 'すごい！1ヶ月連続！',
  reviewItems: '個',
  reviewTodayLabel: '今日の復習問題',
  reviewGoLabel: '📚 復習する →',

  creditBuyBtn: 'クレジット購入',
  creditBuyTitle: 'AIクレジット購入',
  creditBuyDesc: 'Speaking/Writing AIフィードバックとAI練習用の追加クレジットを購入します。',
  creditBuyError: '決済の開始に失敗しました',
  creditBuyNote: 'PayPal決済。決済完了後すぐにクレジットが追加されます。',
  creditUnit: 'クレジット',

  speakingPageH1: 'TOEFL Speaking 練習 2026',
  speakingPageSub: '{count}+ 無料 Speaking — Listen and Repeat · Interview · 模範解答',
  speakingPageTitle: 'TOEFL Speaking 練習 2026 — {count}+ 無料プロンプト & 模範解答 | Power TOEFL',
  speakingPageDesc: 'TOEFL Speaking 練習問題 {count}+個。模範解答、採点基準、AIフィードバック付き。2026年最新。',
  speakingAllTasks: 'すべて',
  speakingNoPrompts: 'まだSpeakingプロンプトがありません',
  speakingNoPromptsSub: 'プロンプトを生成中です。しばらくお待ちください！',
  speakingResponseTime: '応答時間',

  writingPageH1: 'TOEFL Writing 練習 2026',
  writingPageSub: '{count}+ 無料 Writing — Build a Sentence · Email · Academic Discussion',
  writingPageTitle: 'TOEFL Writing 練習 2026 — {count}+ 無料課題 | Power TOEFL',
  writingPageDesc: 'TOEFL Writing 練習 {count}+個。模範解答、採点基準付き。2026年最新。',
  writingAllTasks: 'すべて',
  writingNoPrompts: 'まだWritingプロンプトがありません',
  writingNoPromptsSub: 'プロンプトを生成中です。しばらくお待ちください！',

  catPageTitle: 'TOEFL適応型テスト(CAT) — AI難易度自動調整 | Power TOEFL',
  catPageDesc: 'TOEFLコンピュータ適応型練習試験。AIが正答率に応じて難易度を自動調整します。',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: '正答率に応じて難易度が自動調整されます。1セッション{count}問。',
  catNote: "ℹ️ 注意: 実際のTOEFL iBTはリニア（非適応型）テストです。このPractice CATは実力に応じて難易度を調整し、自分のレベルをすばやく把握するための学習ツールであり、実際の試験形式を再現するものではありません。",
  catSelectSection: 'セクション選択',
  catStartBtn: 'Adaptive Test 開始',
  catLoading: '次の問題を読み込み中...',
  catNoMore: 'これ以上問題がありません',
  catComplete: 'Adaptive Test 完了',
  catAccuracy: '正答率',
  catFinalLevel: '最終難易度',
  catTryAgain: 'もう一度',
  catViewResults: '結果を見る',
  catNext: '次へ',
  catExplanation: '解説',
  catStop: '停止',
  catPlayAudio: '🔊 音声再生',
  catReadingPassage: 'Reading Passage',

  scoreReadingHeader: 'Reading (0~30点)',
  scoreListeningHeader: 'Listening (0~30点)',
  scoreSpeakingHeader: 'Speaking (0~30点)',
  scoreWritingHeader: 'Writing (0~30点)',
  scoreSpeakingDesc: '4つの課題を0~4点で採点後、30点に換算',
  scoreWritingDesc: '2つの課題を0~5点で採点後、30点に換算',
  scoreSpeakingLevels: [
    ['4点 (Good)', '27~30点', '流暢で正確な回答、論理的な展開'],
    ['3点 (Fair)', '19~26点', '概ね明確だが一部誤りあり'],
    ['2点 (Limited)', '11~18点', '基本的な意思疎通は可能だが限定的'],
    ['1点 (Weak)', '1~10点', '意味の伝達が困難'],
  ] as [string, string, string][],
  scoreWritingLevels: [
    ['5点 (Good)', '27~30点', '論理的で具体的なエッセイ、文法正確'],
    ['4点 (Fair)', '22~26点', '全体的に良いが一部不十分'],
    ['3点 (Limited)', '15~21点', '基本構造はあるが展開不足'],
    ['2点 (Weak)', '8~14点', '主題から外れるか構造不明確'],
    ['1点 (Very Weak)', '1~7点', 'ほぼ意味伝達不可'],
  ] as [string, string, string][],
  scoreGuideDescs: [
    'Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+ が必要。上位大学への入学可能。',
    'Reading 22+ / Listening 22+ を目標に。ほとんどの大学の入学基準を満たす。',
    '基本的な学術英語レベル。条件付き入学可能。集中学習が必要。',
    '基礎段階。ReadingとListeningの集中学習を推奨。',
  ],
  // --- Flashcard mode ---
  vocabFlashcardStart: "フラッシュカード開始",
  vocabFlashcardStop: "フラッシュカード停止",
  vocabFlashcardEmpty: "単語を追加してからフラッシュカードを開始してください。",
  vocabFlashcardSpeed: "速度",
  vocabFlashcardSpeedSlow: "ゆっくり",
  vocabFlashcardSpeedNormal: "普通",
  vocabFlashcardSpeedFast: "速い",
  vocabFlashcardShuffle: "シャッフル",
  vocabFlashcardPrev: "前へ",
  vocabFlashcardNext: "次へ",
  vocabFlashcardFlip: "めくる",
  vocabFlashcardProgress: "{current} / {total}",
};

export default ja;
